<!-- 2026-10-18：按用户要求暂时隐藏语言设置入口，保留翻译与已保存的语言偏好。 -->
<!-- 2026-10-18：提供维语选择并保留各语言自称，切换不刷新业务页面。 -->
<template>
  <a-dropdown v-if="false" v-model:visible="visible">
    <div class="lang-wrapper"><svg-icon icon="language" class="svgi" style="width: 24px;margin-right: 20px;"></svg-icon></div>
    <template #overlay>
      <a-menu @click="handleMenuClick">
        <a-menu-item @click="langClick('zh')" key="1">简体中文</a-menu-item>
        <a-menu-item @click="langClick('en')" key="2">English</a-menu-item>
        <a-menu-item @click="langClick('ug')" key="3" dir="rtl">ئۇيغۇرچە</a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import { MenuInfo } from '@/Interfaces/user/user'
import { useI18n } from 'vue-i18n'
import store from '@/store'
export default defineComponent({
  setup(){
    const visible = ref(false)
    const i18n = useI18n()
    const handleMenuClick = (e: MenuInfo) => {
      visible.value = false
    }
    const langClick = (lang: string) => {
      store.commit('app/changeLanguage', lang)
      i18n.locale.value = lang
    }
    return {
      handleMenuClick,langClick,visible
    }
  }
})

</script>
<style lang="scss" scoped>
.lang-wrapper {
  svg {
    width: 35px;
    height: 35px;
    padding: 5px;
    cursor: pointer;
    transition: background 0.5s;
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
